import React, { Dispatch, SetStateAction, isValidElement } from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';

import { isElementOfType } from '../../utilities/components';

import WpIcon from '../icon/WpIcon';

import './WpMenuItem.scss';

type Dispatcher<S> = Dispatch<SetStateAction<S>>;

export interface Props {
  children?: React.ReactNode;
  activeItemId?: string;
  onClick?: Dispatcher<string>;
  menuItemId?: string;
  to?: string;
  exact?: boolean;
  innerRef?: { current: HTMLLIElement };
  qaTest?: string;
}

const WpMenuItem: React.FC<Props> = ({
  children,
  activeItemId,
  menuItemId = '',
  onClick,
  innerRef,
  to,
  exact = false,
  qaTest,
}: Props) => {
  const isActive = activeItemId === menuItemId;
  const classNamePrefix = 'WpMenuItem';
  const classes = classnames(
    classNamePrefix,
    `${classNamePrefix}--color-default`,
    isActive ? `${classNamePrefix}--active` : false
  );

  const renderChildren = () => {
    return React.Children.map(children, (child: React.ReactElement<any>) => {
      if (child && isElementOfType(child, WpIcon)) {
        return <span className={`${classNamePrefix}__icon`}>{React.cloneElement(child)}</span>;
      } else if (isValidElement(child)) {
        return React.cloneElement(child);
      }
      return child;
    });
  };

  const handleOnClick = () => {
    if (onClick) onClick(menuItemId);
  };

  return (
    <>
      {to ? (
        <NavLink
          to={to}
          exact={exact}
          ref={innerRef}
          className={classes}
          onClick={handleOnClick}
          activeClassName={`${classNamePrefix}--active`}
          data-test={qaTest}
        >
          {renderChildren()}
        </NavLink>
      ) : (
        <li ref={innerRef} className={classes} onClick={handleOnClick} data-test={qaTest}>
          {renderChildren()}
        </li>
      )}
    </>
  );
};

export default WpMenuItem;
